import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import CustomEntityBuilder from '@/components/builder/custom-entity-builder';

const customEntityRouteSchema = z.object({
  mode: z.enum(['create', 'update']).optional(),
  entity: z.number().optional(),
});

export const Route = createFileRoute(
  '/_app/(custom-entities)/custom-entities/builder/'
)({
  component: CustomEntitiesBuilderPage,
  validateSearch: zodSearchValidator(customEntityRouteSchema),
});

function CustomEntitiesBuilderPage() {
  return <CustomEntityBuilder />;
}
